import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Remote from "../components/equipments/Remote";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const RemotePage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "ریموت",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <Remote />
          <RoomEquipmentsList />
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default RemotePage;
